var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  model: _vm.searchForm,
                  "label-width": "80px",
                  "label-position": "left",
                  size: "small"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 12 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "姓名" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "姓名", clearable: "" },
                              model: {
                                value: _vm.searchForm.username,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "username", $$v)
                                },
                                expression: "searchForm.username"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "手机" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "手机号模糊搜索",
                                clearable: ""
                              },
                              model: {
                                value: _vm.searchForm.telephone,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "telephone", $$v)
                                },
                                expression: "searchForm.telephone"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工作地点" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择工作地点",
                                  clearable: "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.searchForm.workplace_name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.searchForm,
                                      "workplace_name",
                                      $$v
                                    )
                                  },
                                  expression: "searchForm.workplace_name"
                                }
                              },
                              _vm._l(_vm.workplaceOptions, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "计费岗位" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择计费岗位",
                                  clearable: "",
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.searchForm.billing_position,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.searchForm,
                                      "billing_position",
                                      $$v
                                    )
                                  },
                                  expression: "searchForm.billing_position"
                                }
                              },
                              _vm._l(_vm.billingPositionOptions, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 12 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "label-select-item",
                            attrs: { label: "技能标签" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择技能标签",
                                  clearable: "",
                                  filterable: "",
                                  multiple: ""
                                },
                                model: {
                                  value: _vm.searchForm.label,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "label", $$v)
                                  },
                                  expression: "searchForm.label"
                                }
                              },
                              _vm._l(_vm.labelOptions, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "是否可用" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "是否可用"
                                },
                                model: {
                                  value: _vm.searchForm.enable,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.searchForm,
                                      "enable",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "searchForm.enable"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "是", value: 1 }
                                }),
                                _c("el-option", {
                                  attrs: { label: "否", value: 0 }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 12 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handleReset }
                            },
                            [_vm._v("重置")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.debouncedExport }
                            },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("人员详情")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.upgradeDcopsStaff }
                  },
                  [_vm._v("更新在库人员")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function($event) {
                        _vm.showContactUploadDialog = true
                      }
                    }
                  },
                  [_vm._v("上传企业通讯录")]
                ),
                _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                  _vm._v("表头设置")
                ])
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.faults, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" }
                }),
                _vm._l(_vm.visibleColumns, function(column, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      width: column.width,
                      align: column.align,
                      fixed: column.fixed
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              column.prop === "operation"
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleViewDetail(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("查看详情")]
                                      )
                                    ],
                                    1
                                  )
                                : column.prop === "opTicketid"
                                ? _c("span", [
                                    scope.row.opTicketid
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                                scope.row.opTicketid +
                                                "&isHistory=1",
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v(_vm._s(scope.row.opTicketid))]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.opTicketid || "-")
                                          )
                                        ])
                                  ])
                                : column.prop === "PN"
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            content: scope.row.PN,
                                            placement: "top",
                                            disabled:
                                              !scope.row.PN ||
                                              scope.row.PN.length <= 8
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "ellipsis-text" },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.PN || "-")
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : column.prop === "feedback_status"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.feedback_status === "已完成"
                                            ? "success"
                                            : scope.row.feedback_status ===
                                              "处理中"
                                            ? "warning"
                                            : scope.row.feedback_status ===
                                              "待处理"
                                            ? "info"
                                            : "danger",
                                        size: "small"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row.feedback_status || "-"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "time_out"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.time_out === "已超时"
                                            ? "danger"
                                            : "success",
                                        size: "small"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(scope.row.time_out || "-") +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "enable"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.enable === 1
                                            ? "success"
                                            : "danger",
                                        size: "small"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row.enable === 1 ? "是" : "否"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "label"
                                ? _c(
                                    "div",
                                    { staticClass: "skill-tag-container" },
                                    [
                                      _vm.formatSkillLabels(scope.row.label)
                                        .length
                                        ? _vm._l(
                                            _vm.formatSkillLabels(
                                              scope.row.label
                                            ),
                                            function(skill, skillIndex) {
                                              return _c(
                                                "el-tag",
                                                {
                                                  key:
                                                    (scope.row.keji_account ||
                                                      scope.$index) +
                                                    "-" +
                                                    skillIndex,
                                                  staticClass: "skill-tag",
                                                  attrs: {
                                                    size: "small",
                                                    type: "success"
                                                  }
                                                },
                                                [_vm._v(_vm._s(skill))]
                                              )
                                            }
                                          )
                                        : _c("span", [_vm._v("-")])
                                    ],
                                    2
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row[column.prop] || "-")
                                    )
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                })
              ],
              2
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  "append-to-body": true,
                  width: "400px",
                  "close-on-click-modal": false,
                  "custom-class": "columns-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "上传企业通讯录",
                  visible: _vm.showContactUploadDialog,
                  "append-to-body": true,
                  width: "600px",
                  "close-on-click-modal": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showContactUploadDialog = $event
                  }
                }
              },
              [
                _c("div", { staticClass: "upload-tip" }, [
                  _vm._v(
                    "\n          请上传企业微信导出的通讯录 Excel。文件前几行应为合并的说明文字，其后一行非合并表头（含姓名、账号、手机、邮箱），再下方为人员数据。\n        "
                  )
                ]),
                _c(
                  "el-upload",
                  {
                    ref: "contactUploadRef",
                    staticClass: "upload-drag",
                    attrs: {
                      action: "#",
                      "auto-upload": false,
                      "on-change": _vm.handleContactFileChange,
                      "on-remove": _vm.handleContactFileRemove,
                      "on-exceed": _vm.handleContactFileExceed,
                      "file-list": _vm.contactFileList,
                      accept: ".xlsx,.xls",
                      limit: 1,
                      drag: ""
                    }
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v("将文件拖到此处，或"),
                      _c("em", [_vm._v("点击上传")])
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "el-upload__tip",
                        attrs: { slot: "tip" },
                        slot: "tip"
                      },
                      [
                        _vm._v(
                          "只能上传 .xlsx/.xls 格式的 Excel 文件，仅支持单个文件"
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.showContactUploadDialog = false
                          }
                        }
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          loading: _vm.contactUploadLoading
                        },
                        on: { click: _vm.submitContactUpload }
                      },
                      [_vm._v("上传")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }